import { css } from 'styled-components'

export const BANNER_BUTTON_COLOR_OVERRIDE_CLASS_NAME = 'banner-button-color-override'
export const BANNER_BUTTON_TEXT_COLOR_VAR = '--banner-button-text-color'
export const BANNER_BUTTON_PRIMARY_CONTRAST_COLOR_VAR = '--banner-button-primary-contrast-color'
const DEFAULT_PRIMARY_CONTRAST_COLOR = '#FFFFFF'

export const createBannerButtonColorVariables = (
  textColor: string,
  primaryContrastColor = DEFAULT_PRIMARY_CONTRAST_COLOR,
) => `
  ${BANNER_BUTTON_TEXT_COLOR_VAR}: ${textColor};
  ${BANNER_BUTTON_PRIMARY_CONTRAST_COLOR_VAR}: ${primaryContrastColor};
`

export const createBannerButtonColorStyles = (selector: string) => css`
  ${selector}.kind-tertiary {
    --button-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-hover-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-focus-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-active-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-focus-ring-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-hover-background-color: transparent;
    --button-focus-background-color: transparent;
    --button-active-background-color: transparent;
  }

  ${selector}.kind-secondary {
    --button-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-hover-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-focus-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-active-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-border-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-hover-border-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-focus-border-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-active-border-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-hover-background-color: transparent;
    --button-focus-background-color: transparent;
    --button-active-background-color: transparent;
  }

  ${selector}.kind-primary {
    --button-background-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-border-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-color: var(${BANNER_BUTTON_PRIMARY_CONTRAST_COLOR_VAR});
    --button-hover-background-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-hover-border-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-hover-color: var(${BANNER_BUTTON_PRIMARY_CONTRAST_COLOR_VAR});
    --button-focus-background-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-focus-border-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-focus-color: var(${BANNER_BUTTON_PRIMARY_CONTRAST_COLOR_VAR});
    --button-active-background-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-active-border-color: var(${BANNER_BUTTON_TEXT_COLOR_VAR});
    --button-active-color: var(${BANNER_BUTTON_PRIMARY_CONTRAST_COLOR_VAR});
  }
`
